// extracted by mini-css-extract-plugin
export default {"root":"styles_root__89NsQ","buttons":"styles_buttons__e8L80"};